import React from "react";
import { X } from "lucide-react";

/**
 * Individual notification bar component
 * @param {Object} props - Component props
 * @param {string} props.message - Notification message
 * @param {string} props.type - Notification type (info, success, error, warning)
 * @param {Function} props.onClose - Close handler
 * @returns {JSX.Element} The notification bar
 */
const NotificationBar = ({ message, type = "info", onClose }) => {
  // Get background color based on type
  const getBackgroundClass = () => {
    switch (type) {
      case "success":
        return "bg-lime-500 dark:bg-lime-600";
      case "error":
        return "bg-red-500 dark:bg-red-600";
      case "warning":
        return "bg-orange-500 dark:bg-orange-600";
      default:
        return "bg-blue-500 dark:bg-blue-600";
    }
  };

  return (
    <div
      className={`
      absolute top-4 right-4 left-4 
      ${getBackgroundClass()} 
      text-white px-4 py-3 rounded-xl z-50 text-sm 
      flex items-center justify-between 
      shadow-lg backdrop-blur-sm bg-opacity-95
      animate-slide-in
    `}
    >
      <span>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          className="ml-3 text-white hover:text-neutral-200 transition-colors"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
};

export default NotificationBar;
